export const applyDomainSpecificStyles = () => {
  const currentHost = window.location.host;
  const targetDomain = window.config?.domain;

  if (currentHost.startsWith("localhost") || currentHost === targetDomain) {
    if (targetDomain === "member.clubhouseasia.com") {
      document.body.classList.add("cha-domain");
    }
  }
};
